export const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent);
